import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth, AuthProvider } from './hooks/useAuth';
import Login from './pages/Login';
import Patients from './pages/Patients';
import WatiEvents from './pages/WatiEvents';
import TaliazBotV1Events from './pages/TaliazBotV1Events';
import WhatsappAiBot from './pages/WhatsappAiBot';
import Users from './pages/Users';

// Wrapper for protected routes: checks authentication (and optional role).
function PrivateRoute({ children, requiredRole }: { children: React.ReactNode; requiredRole?: string }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (requiredRole && user.role !== requiredRole) return <Navigate to="/" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><Patients /></PrivateRoute>} />
          <Route path="/wati" element={<PrivateRoute><WatiEvents /></PrivateRoute>} />
          {/* Deliberately public, no PrivateRoute — explicit decision, see
              backend/app/routers/taliaz_botv1.py's GET handler for the
              matching backend-side change. Shows real patient WhatsApp
              messages/replies with no auth gate. */}
          <Route path="/taliaz-botv1" element={<TaliazBotV1Events />} />
          {/* Deliberately public, no PrivateRoute — explicit decision
              (2026-08-25, reversed from an earlier "should be protected"
              answer): the product owner wants direct access with no login
              step. Same tradeoff as /taliaz-botv1 above — shows real
              patient WhatsApp messages/replies with no auth gate. */}
          <Route path="/whatsapp-ai-bot" element={<WhatsappAiBot />} />
          <Route path="/users" element={<PrivateRoute requiredRole="admin"><Users /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
